var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:({ 'direction': _vm.$vs.rtl ? 'rtl' : 'ltr' })},[(_vm.params.data.id)?_c('feather-icon',{attrs:{"icon":"EyeIcon","svgClasses":"h-5 w-5 mr-4 hover:text-primary cursor-pointer"},on:{"click":_vm.ViewRecord}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }